(function () {
    'use strict';

    angular
        .module('assets.mybimiboo.com')
        .controller('OrganizationCtrl', OrganizationCtrl);

    function OrganizationCtrl($scope, $state, $stateParams, $location, $http, AuthenticationService, _env, $compile, Uploader) {

        $scope.numeral = numeral;
        $scope.auth = AuthenticationService;

        $scope.order = {
            value: 'name',
            reverse: false
        }

        $scope.setOrder = function(key) {
            if ($scope.order.value == key) {
                $scope.order.reverse = !$scope.order.reverse;
                return;
            }

            $scope.order.value = key;
            $scope.order.reverse = false;
        }

        $scope.getOrderClass = function(key) {
            if ($scope.order.value == key) {
                return $scope.order.reverse ? 'sorting_desc' : 'sorting_asc';
            }

            return 'sorting';
        }

        $scope.canUser = function(permission) {
            return $scope.auth.user.can(permission);
        }

        function setCurrentTab(organization) {
            var categories = [];
            if(organization.has_equipment && $scope.canUser('manage-equipments')) categories.push('equipments');
            if(organization.has_inventory && $scope.canUser('manage-inventories')) categories.push('inventories');
            if(organization.has_software && $scope.canUser('manage-software')) categories.push('software');
            if(organization.has_trademarks && $scope.canUser('manage-intellectual-property')) categories.push('intellectual-property');
            if(organization.has_library && $scope.canUser('manage-library')) categories.push('library');

            var curTab = window.localStorage.getItem($scope.organization.id + '.curTab');
            if (curTab) {
                $scope.curTab = curTab;
            }
            if(categories.indexOf($scope.curTab) <= 0) {
                $scope.curTab = categories[0];
            }
        }

        $scope.setCurTab = function(curTab) {
            if($scope.curTab != curTab) {
                window.localStorage.setItem($scope.organization.id + '.curTab', curTab);
            }
            $scope.curTab = curTab;
        }

        function getOrganization(callback) {
            $http.get(_env.apiUrl + '/organizations/' + $stateParams.id).then(function (response) {
                $scope.organization = response.data;
                $scope.organization.trademarks = _.map($scope.organization.trademarks, function (tm) {
                    tm.categoryTitle = tm.category.title;
                    return tm;
                });
                $scope.organization['library-items'] = _.map($scope.organization['library-items'], function (li) {
                    li.employeeName = li.employee ? li.employee.name : null;
                    li.status = li.employeeName ? li.employeeName : 'available'
                    return li;
                });
                setCurrentTab($scope.organization);
                initEquipmentDataTable($scope.organization.equipment);
                initLibraryDataTable($scope.organization['library-items']);

                if(callback) callback();
            });
        }

        function getSettings(callback) {
            $http.get(_env.apiUrl + '/organizations/settings').then(function (response) {
                $scope.employees = response.data.employees;
                $scope.locations = response.data.locations;
                $scope.inventoryLocations = response.data["inventory-locations"];
                $scope.equipmentCategories = response.data["equipment-categories"];
                $scope.intellectualPropertyCategories = response.data["intellectual-property-categories"];
                $scope.libraryCategories = response.data["library-item-categories"];
                $scope.libraryLanguages = response.data["library-item-languages"];

                if(callback) callback();
            });
        }

        getOrganization(function () {
            getSettings();
        });

        // equipment

        function initEquipmentDataTable(items) {
            $scope.dataLoaded = true;
            $scope.options = {
                bProcessing: true,
                bRetrieve : true,
                bStateSave : true,
                id: uuidv4(),
                dom: 'Bfrtip',
                buttons: [
                    'excelHtml5'
                ],
                pageLength: 50,
                order: [[0, 'desc']],
                bJQueryUI: true,
                bDestroy: true,
                aoColumns: [
                    {
                        "data": "inventory_code",
                        "sTitle": "Num.",
                        "width": '55px'
                    },
                    {
                        "data": "description",
                        "sTitle": "Description",
                        "mRender": function (o) { return '<span class="dotted">' + o + '</span>'; }
                    },
                    {
                        "data": "equipment_category.title",
                        "sTitle": "Category",
                        "mRender": function (o) { return '<span class="dotted">' + o + '</span>'; },
                        "width": '100px'
                    },
                    {
                        "data": "location.title",
                        "sTitle": "Location",
                        "mRender": function (o) { return '<span class="dotted">' + o + '</span>'; },
                        "width": '130px'
                    },
                    {
                        "data": "purchase_price",
                        "sTitle": "Price ($)",
                        "width": '60px',
                        "mRender": function ( o, type, full) { return full.purchase_price + full.shipping_cost; }
                    },
                    {
                        "data": "purchase_date",
                        "sTitle": "Purchased On",
                        "mRender": function (o) { return formatDate(o, 'YYYY-MM-DD'); },
                        "width": '100px'
                    },
                    {
                        "data": "employee.name",
                        "sTitle": "Employee",
                        "mRender": function (o) { return '<span class="dotted">' + o + '</span>'; },
                        "width": '100px;'
                    },
                    {
                        "data": "status",
                        "sTitle": "Status",
                        "mRender": function (o) { return getStatusFlag(o) },
                        "className": "text-center",
                        "width": '100px'
                    },
                    {
                        "mData": null,
                        "bSortable": false,
                        "mRender": function (o) { return '<a href ng-click="showEditEquipmentForm('+ o.id +')"><i class="fa fa-fw fa-pencil-square-o"></i></a>'; },
                        "className": "text-center"
                    }
                ],
                aaData: _.map(items, function (item) {
                    if(item.status == 'forsale') item.status = 'for sale';
                    return item;
                }),
                initComplete: function () {
                    this.api().columns().every( function () {
                        var column = this;
                        var sTitle = $(column.header()).text().trim();
                        if (sTitle != 'Employee' && sTitle != 'Status' && sTitle != 'Category' && sTitle != 'Location') {
                            return;
                        }

                        var select = $('<select class="form-control" style="width: 100%; height: 25px;"><option value="">' + sTitle + '</option></select>')
                            .appendTo( $(column.header()).empty() )
                            .on( 'change', function () {
                                var val = $.fn.dataTable.util.escapeRegex(
                                    $(this).val()
                                );

                                column
                                    .search( val ? '^'+val+'$' : '', true, false )
                                    .draw();


                                window.localStorage.setItem($scope.organization.id + '.equipments.' + sTitle, val);
                            });

                        column.data().unique().sort().each( function ( d, j ) {
                            var filter = window.localStorage.getItem($scope.organization.id + '.equipments.' + sTitle);
                            if(filter && filter == d) {
                                select.append( '<option value="'+d+'" selected>'+d+'</option>' )
                            } else {
                                select.append( '<option value="'+d+'">'+d+'</option>' )
                            }
                        });

                        select.on( 'click', function(e) {
                            e.stopPropagation();
                        });

                        var filter = window.localStorage.getItem($scope.organization.id + '.equipments.' + sTitle);
                        if(filter) {
                            column.search('^' + filter + '$', true, false).draw();
                        }
                    } );
                },
                createdRow: function(row) {
                    // Recompiling so we can bind Angular directive to the DT
                    $compile(angular.element(row).contents())($scope);
                }
            };
        }

        function getStatusFlag(status) {
            if (status == 'active') {
                return '<span class="label label-info">' + status + '</span>';
            } else if (status == 'inactive') {
                return '<span class="label label-warning">' + status + '</span>';
            } else if (status == 'for sale') {
                return '<span class="label label-success">' + status + '</span>';
            } else if (status == 'sold') {
                return '<span class="label label-default">' + status + '</span>';
            } else {
                return '<span>' + status + '</span>';
            }
        }

        $scope.showEditEquipmentForm = function(equipmentId) {
            if (equipmentId) {
                var equipment = _.find($scope.organization.equipment, function (equipment) {
                    return equipment.id == equipmentId;
                });
                $scope.equipment = angular.copy(equipment);
                $scope.equipment.purchase_date = moment($scope.equipment.purchase_date, 'YYYY-MM-DD').format('DD/MM/YYYY')
                if ($scope.equipment.sale_date) {
                    $scope.equipment.sale_date = moment($scope.equipment.sale_date, 'YYYY-MM-DD').format('DD/MM/YYYY')
                }
            } else {
                $scope.equipment = {};

                $http.get(_env.apiUrl + '/equipments/new_equipment_number').then(function (response) {
                    $scope.equipment.inventory_code = response.data.inventory_code;
                });
            }
            $('#modal-equipment').modal('show');
        }

        $scope.saveEquipment = function () {
            if (!$scope.equipment) return;

            if (!$scope.equipment.inventory_code) {
                error('Inventory code is required');
                return;
            }

            if (!$scope.equipment.status) {
                error('Status is required');
                return;
            }

            if (!$scope.equipment.shipping_cost) {
                $scope.equipment.shipping_cost = 0;
            }

            if ($scope.equipment.status == 'sold') {
                if (!$scope.equipment.sale_date) {
                    error('Sale date is required');
                    return;
                }

                if (!$scope.equipment.sale_price && $scope.equipment.sale_price !== 0) {
                    error('Sale price is required');
                    return;
                }
            }

            if (!$scope.equipment.employee_id) {
                error('Employee is required');
                return;
            }

            if (!$scope.equipment.equipment_category_id) {
                error('Category is required');
                return;
            }

            if (!$scope.equipment.location_id) {
                error('Location is required');
                return;
            }

            if (!$scope.equipment.description) {
                error('Description is required');
                return;
            }

            var data = {
                inventory_code: $scope.equipment.inventory_code,
                status: $scope.equipment.status,
                purchase_date: moment($scope.equipment.purchase_date, 'DD/MM/YYYY').format('YYYY-MM-DD'),
                purchase_price: $scope.equipment.purchase_price,
                shipping_cost: $scope.equipment.shipping_cost,
                employee_id: $scope.equipment.employee_id,
                equipment_category_id: $scope.equipment.equipment_category_id,
                location_id: $scope.equipment.location_id,
                description: $scope.equipment.description,
                note: $scope.equipment.note,
                organization_id: $scope.organization.id
            };

            if (data.status == 'for sale') {
                data.status = 'forsale';
            }

            if ($scope.equipment.status == 'sold') {
                data.sale_date = moment($scope.equipment.sale_date, 'DD/MM/YYYY').format('YYYY-MM-DD');
                data.sale_price = $scope.equipment.sale_price;
            }

            $scope.proccessing = true;

            if ($scope.equipment.id) {
                $http.put(_env.apiUrl + '/equipments/' + $scope.equipment.id, data).then(function(response) {
                    $('#modal-equipment').modal('hide');
                    getOrganization();
                    window.location.reload();
                }, function (reason) {
                    Swal.fire({
                        type: 'error',
                        title: 'Oops...',
                        text: JSON.stringify(reason.data, null, 2)
                    });
                });
            } else {
                $http.post(_env.apiUrl + '/equipments', data).then(function(response) {
                    $('#modal-equipment').modal('hide');
                    getOrganization();
                    window.location.reload();
                }, function (reason) {
                    Swal.fire({
                        type: 'error',
                        title: 'Oops...',
                        text: JSON.stringify(reason.data, null, 2)
                    });
                });
            }
        }

        $scope.deleteEquipment = function () {
            Swal.fire({
                title: 'Are you sure?',
                text: "You won't be able to revert this!",
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, delete it!'
            }).then(function (result) {
                if (result.value) {
                    $scope.proccessing = true;
                    $('#modal-equipment').modal('hide');
                    $http.delete(_env.apiUrl + '/equipments/' + $scope.equipment.id).then(function () {
                        getOrganization();
                        Swal.fire({
                            type: 'success',
                            title: 'Equipment successfully deleted',
                            position: 'top-end',
                            timer: 1000
                        }).then(function () {
                            window.location.reload();
                        });
                    }, function (reason) {
                        Swal.fire({
                            type: 'error',
                            title: 'Oops...',
                            text: JSON.stringify(reason.data, null, 2)
                        });
                    });
                }
            });
        }

        // inventory

        $scope.showEditInventoryForm = function(inventory) {
            if (inventory) {
                $scope.inventory = angular.copy(inventory);
            } else {
                $scope.inventory = {};
            }
            $('#modal-inventory').modal('show');
        }

        $scope.saveInventory = function () {
            if (!$scope.inventory) return;

            if (!$scope.inventory.title) {
                error('Title is required');
                return;
            }

            if (!$scope.inventory.quantity) {
                error('Quantity is required');
                return;
            }

            var data = {
                title: $scope.inventory.title,
                quantity: $scope.inventory.quantity,
                organization_id: $scope.organization.id
            };

            $scope.proccessing = true;

            if ($scope.inventory.id) {
                $http.put(_env.apiUrl + '/inventories/' + $scope.inventory.id, data).then(function(response) {
                    $('#modal-inventory').modal('hide');
                    getOrganization();
                }, function (reason) {
                    Swal.fire({
                        type: 'error',
                        title: 'Oops...',
                        text: JSON.stringify(reason.data, null, 2)
                    });
                });
            } else {
                $http.post(_env.apiUrl + '/inventories', data).then(function(response) {
                    $('#modal-inventory').modal('hide');
                    getOrganization();
                }, function (reason) {
                    Swal.fire({
                        type: 'error',
                        title: 'Oops...',
                        text: JSON.stringify(reason.data, null, 2)
                    });
                });
            }
        }

        $scope.deleteInventory = function () {
            Swal.fire({
                title: 'Are you sure?',
                text: "You won't be able to revert this!",
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, delete it!'
            }).then(function (result) {
                if (result.value) {
                    $scope.proccessing = true;
                    $('#modal-inventory').modal('hide');
                    $http.delete(_env.apiUrl + '/inventories/' + $scope.inventory.id).then(function () {
                        getOrganization();
                        Swal.fire({
                            type: 'success',
                            title: 'Inventory successfully deleted',
                            position: 'top-end',
                            timer: 1000
                        });
                    }, function (reason) {
                        Swal.fire({
                            type: 'error',
                            title: 'Oops...',
                            text: JSON.stringify(reason.data, null, 2)
                        });
                    });
                }
            });
        }

        // intellectualProperty

        $scope.showEditIntellectualPropertyForm = function(intellectualProperty) {
            if (intellectualProperty) {
                $scope.intellectualProperty = angular.copy(intellectualProperty);
            } else {
                $scope.intellectualProperty = {};
            }
            $('#modal-intellectual-property').modal('show');
        }

        $scope.saveIntellectualProperty = function () {
            if (!$scope.intellectualProperty) return;

            if (!$scope.intellectualProperty.title) {
                error('Title is required');
                return;
            }

            if (!$scope.intellectualProperty.trademark_category_id) {
                error('Category is required');
                return;
            }

            var data = {
                title: $scope.intellectualProperty.title,
                description: $scope.intellectualProperty.description,
                organization_id: $scope.organization.id,
                trademark_category_id: $scope.intellectualProperty.trademark_category_id
            };

            $scope.proccessing = true;

            if ($scope.intellectualProperty.id) {
                $http.put(_env.apiUrl + '/intellectual-properties/' + $scope.intellectualProperty.id, data).then(function(response) {
                    $('#modal-intellectual-property').modal('hide');
                    getOrganization();
                }, function (reason) {
                    Swal.fire({
                        type: 'error',
                        title: 'Oops...',
                        text: JSON.stringify(reason.data, null, 2)
                    });
                });
            } else {
                $http.post(_env.apiUrl + '/intellectual-properties', data).then(function(response) {
                    $('#modal-intellectual-property').modal('hide');
                    getOrganization();
                }, function (reason) {
                    Swal.fire({
                        type: 'error',
                        title: 'Oops...',
                        text: JSON.stringify(reason.data, null, 2)
                    });
                });
            }
        }

        $scope.deleteIntellectualProperty = function () {
            Swal.fire({
                title: 'Are you sure?',
                text: "You won't be able to revert this!",
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, delete it!'
            }).then(function (result) {
                if (result.value) {
                    $scope.proccessing = true;
                    $('#modal-intellectual-property').modal('hide');
                    $http.delete(_env.apiUrl + '/intellectual-properties/' + $scope.intellectualProperty.id).then(function () {
                        getOrganization();
                        Swal.fire({
                            type: 'success',
                            title: 'Intellectual properties successfully deleted',
                            position: 'top-end',
                            timer: 1000
                        });
                    }, function (reason) {
                        Swal.fire({
                            type: 'error',
                            title: 'Oops...',
                            text: JSON.stringify(reason.data, null, 2)
                        });
                    });
                }
            });
        }

        // software

        $scope.showEditSoftwareForm = function(software) {
            if (software) {
                $scope.software = angular.copy(software);
                $scope.software.employees = _.map($scope.software.users, function (user) {
                    return user.employee;
                });

                $scope.software.purchase_date =  moment($scope.software.purchase_date, 'YYYY-MM-DD').format('DD/MM/YYYY');
                if($scope.software.expires_date) {
                    $scope.software.expires_date =  moment($scope.software.expires_date, 'YYYY-MM-DD').format('DD/MM/YYYY')
                }
            } else {
                $scope.software = {};
                $scope.software.employees = [];
            }

            $scope.software.onEquipmentEmployeeSelected = function() {
                if (!$scope.software.new_employee_id) return;

                var selectedEmployee = _.find($scope.employees, function (employee) {
                    return employee.id == $scope.software.new_employee_id;
                });

                if (!selectedEmployee) return;

                if(!_.find($scope.software.employees, function (employee) {
                    return selectedEmployee.id == employee.id;
                })) {
                   $scope.software.employees.push(selectedEmployee);
                }
            }

            $scope.software.deleteEmployee = function(index) {
                $scope.software.employees.splice(index, 1);
            }

            $('#modal-software').modal('show');
        }

        $scope.saveSoftware = function () {
            if (!$scope.software) return;

            if (!$scope.software.title) {
                error('Title is required');
                return;
            }

            if (!$scope.software.price) {
                error('Price is required');
                return;
            }

            if (!$scope.software.purchase_date) {
                error('Purchase date is required');
                return;
            }

            var data = {
                title: $scope.software.title,
                description: $scope.software.description,
                price: $scope.software.price,
                purchase_date: moment($scope.software.purchase_date, 'DD/MM/YYYY').format('YYYY-MM-DD'),
                organization_id: $scope.organization.id,
                employees: _.map($scope.software.employees, function (employee) {
                    return employee.id;
                })
            };

            if ($scope.software.expires_date) {
                data.expires_date = moment($scope.software.expires_date, 'DD/MM/YYYY').format('YYYY-MM-DD');
            }

            $scope.proccessing = true;

            if ($scope.software.id) {
                $http.put(_env.apiUrl + '/software/' + $scope.software.id, data).then(function(response) {
                    $('#modal-software').modal('hide');
                    getOrganization();
                }, function (reason) {
                    Swal.fire({
                        type: 'error',
                        title: 'Oops...',
                        text: JSON.stringify(reason.data, null, 2)
                    });
                });
            } else {
                $http.post(_env.apiUrl + '/software', data).then(function(response) {
                    $('#modal-software').modal('hide');
                    getOrganization();
                }, function (reason) {
                    Swal.fire({
                        type: 'error',
                        title: 'Oops...',
                        text: JSON.stringify(reason.data, null, 2)
                    });
                });
            }
        }

        $scope.deleteSoftware = function () {
            Swal.fire({
                title: 'Are you sure?',
                text: "You won't be able to revert this!",
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, delete it!'
            }).then(function (result) {
                if (result.value) {
                    $scope.proccessing = true;
                    $('#modal-software').modal('hide');
                    $http.delete(_env.apiUrl + '/software/' + $scope.software.id).then(function () {
                        getOrganization();
                        Swal.fire({
                            type: 'success',
                            title: 'Software successfully deleted',
                            position: 'top-end',
                            timer: 1000
                        });
                    }, function (reason) {
                        Swal.fire({
                            type: 'error',
                            title: 'Oops...',
                            text: JSON.stringify(reason.data, null, 2)
                        });
                    });
                }
            });
        }

        // library items

        function initLibraryDataTable(items) {
            $scope.libraryDataLoaded = true;
            $scope.libraryDataTableOptions = {
                dom: 'Bfrtip',
                buttons: [
                    'excelHtml5'
                ],
                pageLength: 50,
                order: [[0, 'desc']],
                bJQueryUI: true,
                bDestroy: true,
                aoColumns: [
                    {
                        "data": "inventory_code",
                        "sTitle": "Num.",
                    },
                    {
                        "data": "title",
                        "sTitle": "Title",
                        "mRender": function (o) { return '<span class="dotted">' + o + '</span>'; }
                    },
                    {
                        "data": "category.title",
                        "sTitle": "Category",
                        "mRender": function (o) { return o; },
                    },
                    {
                        "data": "author",
                        "sTitle": "Author",
                        "mRender": function (o) { return o; },
                    },
                    {
                        "data": "language.title",
                        "sTitle": "Language",
                        "mRender": function (o) { return o; }
                    },
                    {
                        "data": "purchase_price",
                        "sTitle": "Price ($)",
                        "mRender": function ( o, type, full) { return numeral(full.purchase_price + full.shipping_cost).format('$0,0.00'); }
                    },
                    {
                        "data": "purchase_date",
                        "sTitle": "Purchased On",
                        "mRender": function (o) { return formatDate(o); }
                    },
                    {
                        "data": "status",
                        "sTitle": "Status",
                        "mRender": function ( o, type, full) {
                            if (!full.employee) {
                                return '<span class="label label-info">available</span>';
                            } else {
                                return '<div class="dotted">' + full.employee.name + '</div>' + '<div class="text-muted">' + formatDate(full.taken_date) + '</div>';
                            }
                        }
                    },
                    {
                        "mData": null,
                        "bSortable": false,
                        "mRender": function (o) { return '<a href ng-click="showLibraryItemForm('+ o.id +')"><i class="fa fa-fw fa-pencil-square-o"></i></a>'; },
                        "className": "text-center"
                    }
                ],
                aaData: _.map(items, function (item) {
                    return item;
                }),
                initComplete: function () {
                    this.api().columns().every( function () {
                        var column = this;
                        var sTitle = $(column.header()).text().trim();
                        if (sTitle != 'Category' && sTitle != 'Author' && sTitle != 'Status' && sTitle != 'Language') {
                            return;
                        }

                        var select = $('<select class="form-control" style="width: 100%; height: 25px;"><option value="">' + sTitle + '</option></select>')
                            .appendTo( $(column.header()).empty() )
                            .on( 'change', function () {
                                var val = $.fn.dataTable.util.escapeRegex(
                                    $(this).val()
                                );

                                column
                                    .search( val, true, false )
                                    .draw();

                                window.localStorage.setItem($scope.organization.id + '.library.' + sTitle, val);
                            } );

                        var filter = window.localStorage.getItem($scope.organization.id + '.library.' + sTitle);
                        column.data().unique().sort().each( function ( d, j ) {
                            if(filter && filter == d) {
                                select.append( '<option value="'+d+'" selected>'+d+'</option>' )
                            } else {
                                select.append( '<option value="'+d+'">'+d+'</option>' )
                            }
                        });

                        select.on( 'click', function(e) {
                            e.stopPropagation();
                        });

                        var filter = window.localStorage.getItem($scope.organization.id + '.library.' + sTitle);
                        if(filter) {
                            column.search(filter, true, false).draw();
                        }
                    } );
                },
                createdRow: function(row) {
                    // Recompiling so we can bind Angular directive to the DT
                    $compile(angular.element(row).contents())($scope);
                }
            };
        }

        function getStatusFlag(status) {
            if (status == 'active') {
                return '<span class="label label-info">' + status + '</span>';
            } else if (status == 'inactive') {
                return '<span class="label label-warning">' + status + '</span>';
            } else if (status == 'for sale') {
                return '<span class="label label-success">' + status + '</span>';
            } else if (status == 'sold') {
                return '<span class="label label-default">' + status + '</span>';
            } else {
                return '<span>' + status + '</span>';
            }
        }

        $scope.showLibraryItemForm = function(libraryItemId) {
            if (libraryItemId) {

                var libraryItem = _.find($scope.organization['library-items'], function (item) {
                    return item.id == libraryItemId;
                });

                $scope.libraryItem = angular.copy(libraryItem);
                $scope.libraryItem.purchase_date = moment($scope.libraryItem.purchase_date, 'YYYY-MM-DD').format('DD/MM/YYYY');
                if ($scope.libraryItem.taken_date) {
                    $scope.libraryItem.taken_date = moment($scope.libraryItem.taken_date, 'YYYY-MM-DD').format('DD/MM/YYYY');
                }
            } else {
                $scope.libraryItem = {};
                $http.get(_env.apiUrl + '/equipments/new_equipment_number').then(function (response) {
                    $scope.libraryItem.inventory_code = response.data.inventory_code;
                });
            }
            $('#modal-library-item').modal('show');
        }

        $scope.saveLibraryItem = function () {
            if (!$scope.libraryItem) return;

            if (!$scope.libraryItem.title) {
                error('Title is required');
                return;
            }

            if (!$scope.libraryItem.author) {
                error('Author is required');
                return;
            }

            if (!$scope.libraryItem.description) {
                error('Description is required');
                return;
            }

            if (!$scope.libraryItem.library_item_category_id) {
                error('Author is required');
                return;
            }

            if (!$scope.libraryItem.library_item_language_id) {
                error('Language is required');
                return;
            }

            var data = {
                inventory_code: $scope.libraryItem.inventory_code,
                title: $scope.libraryItem.title,
                description: $scope.libraryItem.description,
                author: $scope.libraryItem.author,
                purchase_date: $scope.libraryItem.purchase_date,
                purchase_price: $scope.libraryItem.purchase_price,
                shipping_cost: $scope.libraryItem.shipping_cost,
                taken_by: $scope.libraryItem.taken_by,
                taken_date: $scope.libraryItem.taken_date,
                library_item_category_id: $scope.libraryItem.library_item_category_id,
                library_item_language_id: $scope.libraryItem.library_item_language_id,
                organization_id: $scope.organization.id
            };

            data.purchase_date = moment(data.purchase_date, 'DD/MM/YYYY').format('YYYY-MM-DD');
            if(data.taken_by) {
                if (data.taken_date) {
                    data.taken_date = moment(data.taken_date, 'DD/MM/YYYY').format('YYYY-MM-DD');
                }
            } else {
                data.taken_date = null;
            }

            $scope.proccessing = true;


            function callback() {
                $('#modal-library-item').modal('hide');
                getOrganization();
            }

            if ($scope.libraryItem.id) {
                $http.put(_env.apiUrl + '/library-items/' + $scope.libraryItem.id, data).then(function(response) {
                    if ($scope.libraryItem.photo) {
                        uploadLibraryItemPhoto(callback)
                    } else {
                        callback();
                    }
                }, function (reason) {
                    Swal.fire({
                        type: 'error',
                        title: 'Oops...',
                        text: JSON.stringify(reason.data, null, 2)
                    });
                });
            } else {
                $http.post(_env.apiUrl + '/library-items', data).then(function(response) {
                    $scope.libraryItem.id = response.data.id;
                    if ($scope.libraryItem.photo) {
                        uploadLibraryItemPhoto(callback);
                    } else {
                        callback();
                    }
                }, function (reason) {
                    Swal.fire({
                        type: 'error',
                        title: 'Oops...',
                        text: JSON.stringify(reason.data, null, 2)
                    });
                });
            }
        }

        $scope.deleteLibraryItem = function () {
            Swal.fire({
                title: 'Are you sure?',
                text: "You won't be able to revert this!",
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, delete it!'
            }).then(function (result) {
                if (result.value) {
                    $scope.proccessing = true;
                    $('#modal-library-item').modal('hide');
                    $http.delete(_env.apiUrl + '/library-items/' + $scope.libraryItem.id).then(function () {
                        window.location.reload();
                        Swal.fire({
                            type: 'success',
                            title: 'Library Item successfully deleted',
                            position: 'top-end',
                            timer: 1000
                        });
                    }, function (reason) {
                        Swal.fire({
                            type: 'error',
                            title: 'Oops...',
                            text: JSON.stringify(reason.data, null, 2)
                        });
                    });
                }
            });
        }

        function uploadLibraryItemPhoto(callback) {
            if ($scope.libraryItem.photo && $scope.libraryItem.photo.attachable_id === undefined) {
                Uploader.uploadFilesToUrl([$scope.libraryItem.photo], _env.apiUrl + '/uploads?attachable_type=library_item&attachable_id=' + $scope.libraryItem.id, '', {
                    'success': function () {
                        if (callback) callback();
                    },
                    'error': function (error) {
                        Swal.fire({
                            type: 'error',
                            title: 'Oops...',
                            text: JSON.stringify(error, null, 2)
                        });
                    }
                });
            } else if (callback) {
                callback();
            }
        }

        $scope.fileDropped = function() {
            var file = $scope.uploadedFile;
            if (!file) return;

            var reader = new FileReader();

            reader.onload = function (e) {
                file.local_src = e.target.result;
                $scope.libraryItem.newPhoto = file;

                $scope.$apply();
            };
            reader.readAsDataURL(file);

            $scope.uploadedFile = null;
        };

        $scope.getLibraryItemPhoto = function () {
            if($scope.libraryItem && $scope.libraryItem.newPhoto) {
                return $scope.libraryItem.newPhoto.local_src;
            } else if ($scope.libraryItem && $scope.libraryItem.photo) {
                return $scope.libraryItem.photo.file_url;
            } else {
                return 'img/profile.png';
            }
        }

        $scope.downloadFile = function(file) {
            var config = { responseType: 'blob' };
            $http.get(_env.apiUrl + '/uploads/download/' + file.id, config).then(function (response) {
                var headers = response.headers();
                var filename = file.file_name;
                var contentType = headers['content-type'];
                var newBlob = new Blob([response.data], { type: contentType });
                var url = window.URL.createObjectURL(newBlob);
                var link = document.createElement('a');
                link.href = url;
                link.download = filename;
                var clickEvent = new MouseEvent("click", {
                    "view": window,
                    "bubbles": true,
                    "cancelable": false
                });
                link.dispatchEvent(clickEvent);
            });
        }

        $scope.libraryItemPhotoChanged = function (fileInput) {
            var file = fileInput.files[0];
            Uploader.uploadFilesToUrl([file], _env.apiUrl + '/uploads?attachable_type=library_item&attachable_id=' + $scope.libraryItem.id, '', {
                'success': function () {
                    getOrganization()
                },
                'error': function (error) {
                    Swal.fire({
                        type: 'error',
                        title: 'Oops...',
                        text: JSON.stringify(error, null, 2)
                    });
                }
            });
        }
    }
})();